import { render, staticRenderFns } from "./TepSolicitudIndex.vue?vue&type=template&id=6060212e"
import script from "./TepSolicitudIndex.vue?vue&type=script&lang=js"
export * from "./TepSolicitudIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports